import { render, staticRenderFns } from "./packageAdd.vue?vue&type=template&id=97f94db6"
import script from "./packageAdd.vue?vue&type=script&lang=js"
export * from "./packageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports